import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import StoreIcon from '@mui/icons-material/Store';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import { AvailabilityType } from '@interfaces';
import { ReactNode } from 'react';
import { getWeekdayName, next24hrsDay } from '@utils';
import { addDays } from 'date-fns';
import { usePermissions } from '@hooks/usePermissions';
import {
  EmptyChip,
  ChipContainer,
  IconContainer,
  Label,
  Container,
} from './AvailabilityChip.styles';

const label: Record<AvailabilityType, string> = {
  AVAILABLE: '',
  get AVAILABLE_24_HRS() {
    const next = next24hrsDay();
    const today = new Date(Date.now());
    if (today.toDateString() === next.toDateString()) return 'Recibe hoy';
    const tomorrow = addDays(today, 1);
    if (tomorrow.toDateString() === next.toDateString()) return 'Recibe mañana';
    return 'Recibe el ' + getWeekdayName(next).toLowerCase();
  },
  CHECK: 'Venta presencial',
  HIDDEN: 'Agotado',
  REPRESENTATION: '',
  SOLD_OUT: 'Agotado',
  TO_CONFIRM: 'A pedido',
  UNAVAILABLE: 'Agotado',
};
const localLabel: Record<AvailabilityType, string> = {
  AVAILABLE: 'Venta online',
  AVAILABLE_24_HRS: 'Disponible',
  CHECK: 'Disponible',
  HIDDEN: 'Agotado',
  REPRESENTATION: 'Venta online',
  SOLD_OUT: 'Agotado',
  TO_CONFIRM: 'A pedido',
  UNAVAILABLE: 'Agotado',
};

const icon: Record<AvailabilityType, ReactNode> = {
  AVAILABLE: '',
  AVAILABLE_24_HRS: <LocalShippingOutlinedIcon />,
  CHECK: <StoreIcon />,
  HIDDEN: <WarningAmberIcon />,
  REPRESENTATION: '',
  SOLD_OUT: <WarningAmberIcon />,
  TO_CONFIRM: <AccessTimeIcon />,
  UNAVAILABLE: <WarningAmberIcon />,
};
const localIcon: Record<AvailabilityType, ReactNode> = {
  AVAILABLE: <PhoneIphoneIcon />,
  AVAILABLE_24_HRS: <StoreIcon />,
  CHECK: <StoreIcon />,
  HIDDEN: <WarningAmberIcon />,
  REPRESENTATION: <PhoneIphoneIcon />,
  SOLD_OUT: <WarningAmberIcon />,
  TO_CONFIRM: <AccessTimeIcon />,
  UNAVAILABLE: <WarningAmberIcon />,
};

interface AvailabilityChipProps {
  availability: AvailabilityType;
  isCheck?: boolean;
}

export const AvailabilityChip = (props: AvailabilityChipProps) => {
  const { availability, isCheck } = props;
  const { userCan } = usePermissions();
  const isLocalVendor = userCan('LOCAL_VENDOR');
  const parsedAvailability = ['UNAVAILABLE', 'SOLD_OUT', 'HIDDEN'].includes(
    availability,
  )
    ? availability
    : isCheck && availability === 'AVAILABLE_24_HRS' && isLocalVendor
    ? availability
    : isCheck
    ? 'CHECK'
    : availability;
  const text = isLocalVendor
    ? localLabel[parsedAvailability]
    : label[parsedAvailability];
  if (!text) return <EmptyChip />;
  return (
    <Container>
      <ChipContainer availability={parsedAvailability}>
        <IconContainer availability={parsedAvailability}>
          {isLocalVendor
            ? localIcon[parsedAvailability]
            : icon[parsedAvailability]}
        </IconContainer>
        <Label availability={parsedAvailability}>{text}</Label>
      </ChipContainer>
    </Container>
  );
};
